export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/signature.ebc071b.svg";